import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "./FeaturedProductsTabs.css";

import Medicine from "./Medicine/Medicine";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";
import { getAllProducts } from "../../../features/products/productsSlice";

function FeaturedProductsTabs() {
  const dispatch = useDispatch();

  const subcategories = useSelector((state) => state.master.subcategories);
  const allProducts = useSelector((state) => state.product.allProducts);

  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    dispatch(
      getAllSubCategory({
        all: false,
        limit: 3,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (subcategories?.length > 0) {
      setActiveTab(subcategories[0].id);

      dispatch(
        getAllProducts({
          subcategory_id: subcategories[0].id,
        }),
      );
    }
  }, [subcategories, dispatch]);

  const handleTabChange = (subcategoryId) => {
    setActiveTab(subcategoryId);

    dispatch(
      getAllProducts({
        subcategory_id: subcategoryId,
      }),
    );
  };
  if (subcategories?.length <= 0) {
    return null;
  }

  return (
    <section className="HealthcareProducts-section FeaturedProductsTabs-section">
      <div className="container container-section">
        <div>
          <h4 className="heading_text">Featured Products</h4>
        </div>

        {subcategories?.length > 0 && (
          <Tabs
            activeKey={activeTab}
            onSelect={handleTabChange}
            centered
            className="custom-tabs"
            mountOnEnter
            unmountOnExit={false}
          >
            {subcategories.map((item) => (
              <Tab key={item.id} eventKey={item.id} title={item.name}>
                <Medicine products={allProducts?.data || []} />
              </Tab>
            ))}
          </Tabs>
        )}
      </div>
    </section>
  );
}

export default FeaturedProductsTabs;
